import { useQuery } from '@apollo/client';
import { CasesSendReportV1SectionLayoutContainerSendReportCaseV1Document } from '../../../../../generated';
import { ComponentQueryLoader } from '../../../../shared/component-query-loader';
import { PageLayoutProps } from '../../../../shared/menu-component';
import { SendReportLayout } from './section-layout';

interface SendReportLayoutContainerProps {
    pageLayouts: PageLayoutProps[];
    caseId: string;
    isApplicantSection?: boolean;
}

export const SendReportLayoutContainer: React.FC<SendReportLayoutContainerProps> = (props) => {

  const { data: caseStateData, loading: caseStateLoading, error: caseStateError } = useQuery(CasesSendReportV1SectionLayoutContainerSendReportCaseV1Document, 
    {
        variables: {
          sendReportCaseV1Id: props.caseId,
        },
      }
  );


  return (
    <ComponentQueryLoader
      error={caseStateError}
      loading={caseStateLoading}
      hasData={caseStateData !== undefined}
      hasDataComponent={
        <SendReportLayout caseState={caseStateData?.sendReportCaseV1?.state ?? ""} pageLayouts={props.pageLayouts}  caseId={props.caseId} caseName={caseStateData?.sendReportCaseV1?.caseName ?? ""} isApplicantSection={props.isApplicantSection}/>
      }
    />
  );
};
